module.exports = __webpack_public_path__ + "img/user.84046402.svg";